/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 49a830b3 (Tue Jan 27 16:18:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  ProgramsPrograms,
  ProgramsProgramsFromJSON,
  ProgramsProgramsToJSON,
} from './'

/**
 * List programs with filtering grouped by academic year.
 * @export
 * @interface Programs
 */
export interface Programs {
  /**
   * The list of programs for the supplied filters grouped by academic year
   * @type {Array<ProgramsPrograms>}
   * @memberof Programs
   */
  programs: Array<ProgramsPrograms>
}

export function ProgramsFromJSON(json: any): Programs {
  return ProgramsFromJSONTyped(json, false)
}

export function ProgramsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Programs {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programs: (json['programs'] as Array<any>).map(ProgramsProgramsFromJSON),
  }
}

export function ProgramsToJSON(value?: Programs | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programs: (value.programs as Array<any>).map(ProgramsProgramsToJSON),
  }
}
